import styled from 'styled-components';

export const Iframe = styled.iframe`
  height: 125vh;
`;